// IMPORTANT - updated September 4th, 2017
// Manual GA Analytics trackers are currently on sunset support
// Please use `data-ga-label` on the element you want to track

'use strict';
var slugify = require('../helpers/slugify');
var $ = window.jQuery;
var gaTracker = require('./gaTracker');

function initUniversal () {
  if (window.wooGlobal.noAnalytics) {
    window['ga-disable-' + window.wooGlobal.settings.analytics.account] = true;
  }
}

function bindUniversal () {
  var pageName = $('body').attr('data-page-name') || '';

  // About page - social network links
  $('body.about .about-share-button').on('click', function () {
    var network = $('img', this).attr('alt').toLowerCase();
    if (network === 'blog') {
      gaTracker('about-blog');
    } else {
      gaTracker('about-follow-us-' + network);
    }
  });

  // About press kit download link
  $('body.about .description a:last').on('click', function () {
    gaTracker('about-presskit-download');
  });

  // Developers page, extension links
  $('body.developers .extension-btn').on('click', function () {
    var extentionType = $(this).attr('data-type');
    gaTracker('developers-extension-' + extentionType);
  });

  // Developers page, logo download
  $('body.developers .dev-assets-imgs a').on('click', function () {
    var logoType = $(this).attr('class');
    gaTracker('developers-logo-' + logoType);
  });

  // Genbar Free trial behind option dropdown
  $('#top .js-generation-bar-in-header .start-trial').on('click', function () {
    gaTracker('free-trial-button', 'click', 'genbar-' + pageName);
  });

  // Genbar review button
  $('#top .js-generation-bar-in-header .generation-bar-btn')
    .on('click', function () {
      gaTracker('button', 'click', 'genbar-review-' + pageName);
    });

  // Home page free trial button top and bottom
  $('body.home .start-trial').on('click', function () {
    var linkName = $(this).attr('name') || '';
    var position = linkName.split('-').pop();
    if (position.length < 1) {
      gaTracker('free-trial-button', 'click', 'homepage-' + position);
    }
  });

  // Home page genbars button
  $('body.home .generation-bar').on('submit', function () {
    var position = $(this).attr('id');
    gaTracker('button', 'submit', 'homepage-' + position);
  });

  // Sign up button on page
  $('#signup-container .link').on('click', function () {
    gaTracker('button', 'click', 'signup-on-page-' + pageName);
  });

  // Signin header button
  $('#login-container .link').on('click', function () {
    gaTracker('button', 'click', 'signin-on-page-' + pageName);
  });

  // Jobs apply now button
  $('body.jobs .js-apply-btn').on('click', function () {
    var jobsTitle = slugify(
      $(this).parents('.panel').find('.panel-title').text() || ''
    );
    if (jobsTitle.length < 1) {
      jobsTitle = 'general';
    }
    gaTracker('button', 'click', 'jobs-apply-' + jobsTitle);
  });

  // Features dropdown links
  $('#top .js-feat-dropdown a').on('click', function () {
    var targetFeat = $(this).attr('href').split('#')[1];
    gaTracker('feat-dropdown-' + targetFeat);
  });

  // Pricing navbar link
  $('#top .js-pricing-link').on('click', function () {
    gaTracker('pricing-navbar-link');
  });

  $('body.pricing .js-switch-yearly').on('click', function () {
    gaTracker('pricing-yearly-tab');
  });

  $('body.pricing .js-switch-monthly').on('click', function () {
    gaTracker('pricing-monthly-tab');
  });

  $('body.pricing .js-trial').on('click', function () {
    gaTracker('pricing-trial-button');
  });

  $('body.pricing #create-ticket').on('click', function (event) {
    gaTracker('pricing-contact-form');
  });

  $('body.pricing .js-enterprise-contact').on('click', function (event) {
    gaTracker('pricing-enterprise-contact-button');
  });

  $('body.pricing .js-skip').on('click', function (event) {
    gaTracker('pricing-skip-paywall');
  });

  $('body.pricing .js-updowngrade .js-choose-plan').on('click', function (event) {
    gaTracker('pricing-choose-plan');
  });

  // Pricing Free Trail premium/pro plan button
  $('body.pricing .js-free-trail-plan').on('click', function () {
    var plan = $(this).attr('data-plan');
    gaTracker('free-trial-button', 'click', 'pricing-' + plan);
  });

  // Embed page logo
  $('body.embed .logo-container').on('click', function () {
    gaTracker('embed-page-logo');
  });

  // Embed page review button
  $('body.embed .generation-bar-btn').on('click', function () {
    gaTracker('embed-page-review-button');
  });

  // User header options links
  $('#top #logged-container .dropdown-menu a').on('click', function () {
    var href = $(this).attr('href') || '';
    var linkTarget = href.split('/').pop();
    gaTracker('user-header-options-' + linkTarget);
  });

  // User download extension button
  $('body.overview .extension-link').on('click', function () {
    var activeBrowser = window.wooGlobal.browser ||
      $(this).attr('data-active-browser');
    gaTracker('user-download-extension-' + activeBrowser);
  });

  // Genbar in options review button
  $('#top .generation-bar .js-options-btn').on('click', function () {
    gaTracker('button', 'click', 'genbar-in-options-review');
  });

  // Overview page options on advance report
  $('body.overview #projects .options-container a').on('click', function () {
    var option = slugify($(this).text());
    gaTracker('overview-advance-options-' + option);
  });

  // Overview pdf template editor link
  $('body.overview .pdf-template-link').on('click', function () {
    gaTracker('overview-pdf-template');
  });

  // Overview show more reports
  $('body.overview .js-next-reports-loader').on('click', function () {
    gaTracker('overview-show-more-report');
  });

  // Overview page options on reports
  $('body.overview #reports .options-container a').on('click', function () {
    var option = slugify($(this).text());
    gaTracker('overview-report-options-' + option);
  });

  // Subuser add user button
  $('body.subusers .subuser-form .submit-button').on('click', function () {
    gaTracker('subusers-add-user');
  });

  // Subuser remove user button
  $('body.subusers .remove-user').on('click', function () {
    gaTracker('subusers-remove-user');
  });

  // Subuser upgrade button
  $('body.subusers #upgrade-button a').on('click', function () {
    gaTracker('subusers-upgrade');
  });

  // Review dashboard share link
  $('.js-dashboard-share')
    .on('click', function () {
      gaTracker('review-share');
    });

  // Review share to social links
  $('.js-social-network')
    .on('click', function () {
      var socialChannel = $(this).attr('site');
      gaTracker('review-share-social-' + socialChannel);
    });

  // Review download pdf CTA
  $('#dashboard-footer .js-pdf-download-container .start-trial')
    .on('free-trial-button', 'click', function () {
      gaTracker('review-dashboard-download-pdf-cta');
    });

  // Review Dashboard Manage Competitors CTA
  $('#dashboard-footer .js-manage-competitors').on('click', function () {
    gaTracker('review-dashboard-manage-competitors-btn');
  });

  // Manage Competitors modal
  $('#generation-bar-in-competitors-modal .js-update-competitors').on('click', function () {
    gaTracker('review-competitors-modal-update-competitors-btn');
  });

  // Dashboard Teaser
  $('.dashboard-teaser .btn').on('click', function () {
    gaTracker('dashboard-teaser-free-trial-btn');
  });

  // Review download slides CTA
  $('#dashboard-footer .js-slides-download-container .start-trial')
    .on('free-trial-button', 'click', function () {
      gaTracker('review-dashboard-slides-pdf-cta');
    });

  // Review criteria question mark click
  $('body.review .criterium-advice-click').on('click', function () {
    var criterium = $(this).parent('.criterium').attr('id');
    gaTracker('review-criteria-info-on-' + criterium);
  });

  // Review Free-trial button CTA
  $('body.review .review-cta').on('.show-modal', 'click', function (event) {
    var criterium = $(event.delegatedTarget).attr('id');
    gaTracker('free-trial-button', 'click', 'review-criterium-cta-on-' + criterium);
  });

  // Experts links on review
  $('body.review .experts-banner .business-card').on('a', 'click', function () {
    var expert;
    var isExpert = !$(this).hasClass('see-all-experts');
    expert = 'all-experts';
    if (isExpert) {
      expert = slugify($(this).text() || $(this).find('img').attr('alt') || '');
    }
    gaTracker('experts-in-review-' + expert);
  });

  // Experts become a expert link
  $('body.review .experts-banner .experts-register').on('click', function () {
    gaTracker('experts-become-a-expert');
  });

  // Marketing checklist item open
  $('body.review .marketing-checklist .container-plus-minus')
    .on('click', function () {
      gaTracker('button', 'click', 'marketing-checklist-item');
    });

  // Marketing checklist show more CTA
  $('body.review .marketing-checklist .container-checkbox')
    .on('click', function () {
      gaTracker('button', 'click', 'marketing-checklist-showmore-cta');
    });

  // Marketing checklist more info links
  $('body.review .marketing-checklist .task-links')
    .on('click', function () {
      gaTracker('button', 'click', 'marketing-checklist-more-info-link');
    });

  // Marketing checklist call to actions
  $('#marketing-checklist .fake-show-more').on('click', function () {
    gaTracker('button', 'click', 'marketing-checklist-cta');
  });

  // Review criteria information links
  $('body.review .criterium').on('criterium-advice a', 'click', function (event) {
    var criterium = $(event.delegatedTarget).attr('id');
    var href = $(this).attr('href');
    var isWoorank = href.indexOf('woorank.com');
    if (isWoorank) {
      gaTracker('review-criteria-information-on-' + criterium);
    } else {
      gaTracker('review-criteria-information-affiliate-on-' + criterium);
    }
  });

  // Review Domain avaibility affiliate links
  $('body.review #criterium-tld_cybersquating_prevention a')
    .on('click', function () {
      gaTracker('review-domain-avaibility-book-it-now');
    });

  // Review technologies
  $('body.review #criterium-technologies a').on('click', function () {
    gaTracker('review-technolohies');
  });

  // Review left menu links
  $('body.review #left-nav .inpage-link').on('click', function () {
    var href = $(this).attr('href') || '';
    var inPageLink = href.split('#').pop();
    gaTracker('review-left-menu-' + inPageLink);
  });

  // Review download pdf
  $('body.review #dashboard-footer .js-pdf-download-container')
    .on('click', function () {
      gaTracker('review-dashboard-download-pdf');
    });

  // Review download slides
  $('body.review #dashboard-footer .js-slides-download-container')
    .on('click', function () {
      gaTracker('review-dashboard-download-slides');
    });

  // Review make advance review
  $('body.review #dashboard-footer .make-advanced-review-container')
    .on('click', function () {
      gaTracker('review-dashboard-advanced-review');
    });

  // Review (advanced) competitors tabs
  $('body.review .criterium').on('.tab', 'click', function (event) {
    var criterium = $(event.delegatedTarget).attr('id');
    gaTracker('review-competitors-tabs-on-' + criterium);
  });

  // Review (advanced) add tracks keywords link (to setting page)
  $('body.review #module-pj_serp .part.text a').on('click', function () {
    gaTracker('review-add-tracks-keywords');
  });

  // Review the regenerate button
  $('body.review #dashboard .js-regenerate').on('click', function () {
    gaTracker('review-regenerate');
  });

  // Review dasboard site link
  $('body.review #dashboard-site h1 a').on('click', function () {
    gaTracker('review-site-link');
  });

  $('#exit-page-modal').on('click', 'a', function () {
    gaTracker('exit-page-links-' + $(this).attr('data-track'));
    if ($('body').hasClass('register')) {
      gaTracker('exit-page-links-creditcard');
    }
  });

  $('#exit-page-modal').on('click', '.close', function () {
    gaTracker('button', 'click', 'exit-page-close');
  });

  // Blog sidebar call-to-action
  $('body.woocms .call-to-action.woorank-boost-cta').on('click', function (e) {
    gaTracker('blog-boost-your-traffic-cta');
  });

  // popup modal review
  $('#homepage-popup-review-modal').on('show.bs.modal', (e) => {
    gaTracker('popup-review-open');
  });
  $('#homepage-popup-review-modal').on('hide.bs.modal', (e) => {
    gaTracker('popup-review-close');
  });
  $('#homepage-popup-review-modal .modal-footer button').on('click', (e) => {
    gaTracker('popup-review-close-btn');
  });
  $('.js-post-review').on('click', (e) => {
    gaTracker('post-popup-trial-cta');
  });

  // Homepage features CTA
  $('.js-homepage-feature-cta').on('click', function (event) {
    var feature = $(this).attr('data-feature');
    gaTracker('homepage-features-cta-' + feature);
  });

  // GA Tracker handler for Clicks
  $('[data-ga-label]').on('click', function (e) {
    if ($(this).attr('data-ga-label')) {
      var label = slugify($(this).attr('data-ga-label'));
      if (label) {
        gaTracker(label);
      }
    }
  });
}

module.exports = {
  init: initUniversal,
  bind: bindUniversal
};
